module.exports = __webpack_public_path__ + "static/media/sketch_04.26584f27.png";